import Navbar from "./Navbar";
import alanBtn from '@alan-ai/alan-sdk-web';
function App() {
  return (
    <div className="App">
      <Navbar />
    </div>
  );
}

export default App;
